import { Label } from '~/components/ui/label'
import { cn } from '~/lib/utils'

export interface FieldProps {
  id?: string
  label?: string
  required?: boolean
  optional?: boolean
  children: React.ReactNode
  error?: string
  className?: string
  labelClassName?: string
  /** Style du texte du libellé (taille, graisse), sans toucher à la mise en page du champ. */
  labelTextClassName?: string
}

/** Premier message d'erreur d'un champ TanStack Form : issue de schéma (`{ message }`) ou texte. */
export const fieldErrorMessage = (errors: readonly unknown[]): string | undefined => {
  for (const error of errors) {
    if (typeof error === 'string' && error !== '') return error
    if (error && typeof error === 'object' && 'message' in error) return String(error.message)
  }
  return undefined
}

export const Field = ({
  id,
  label,
  children,
  error,
  required,
  optional,
  className,
  labelClassName,
  labelTextClassName,
}: FieldProps) => {
  if (!label) {
    return (
      <div className={cn('flex flex-col gap-1', className)} aria-invalid={error ? true : undefined}>
        {children}
        {error && <em className="text-destructive text-xs opacity-70">{error}</em>}
      </div>
    )
  }

  return (
    <div className={cn('flex flex-col gap-1', className)} aria-invalid={error ? true : undefined}>
      <Label htmlFor={id} className={cn('flex flex-col gap-1 items-start', labelClassName)}>
        <span className={cn('text-sm flex gap-0.5 items-center', labelTextClassName)}>
          {label}
          {required && <span className="text-destructive">*</span>}
          {optional && <span className="text-muted-foreground text-xs">(facultatif)</span>}
        </span>
        {children}
      </Label>
      {error && <em className="text-destructive text-xs opacity-70">{error}</em>}
    </div>
  )
}
